var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.checkIsInApp)?_c('div',{staticClass:"btns"},[_c('button',{staticClass:"go-back",on:{"click":_vm.goBack}},[_vm._v("返回")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }